<template>
  <div>
    <QS-h4-title title="支付信息" />
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form class="payInfoFrom" ref='payInfoRef' :model='payInfo'>
      <QS-column-box :column="2">
        <el-form-item
          prop='contractNo'
          label="总押金:"
        >
          <el-input
            v-model.trim="payInfo.deposit"
            v-deleteEmoji="true"
            v-limit-money="true"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop='contractNo'
          label="一次性管理费:"
        >
          <el-input
            v-model.trim="payInfo.manageFee"
            v-deleteEmoji="true"
            v-limit-money="true"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop='contractNo'
          label="其他服务费金额:"
        >
          <el-input
            v-model.trim="payInfo.serviceFee"
            v-deleteEmoji="true"
            v-limit-money="true"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop='contractNo'
          label="备注:"
        >
          <el-input
            v-model="payInfo.remarks"
            type="textarea"
            placeholder="请输入"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </QS-column-box>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      payInfo: {
        deposit: '',
        manageFee: '',
        serviceFee: '',
        remarks: '',
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.payInfoFrom {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
</style>
